// Date of birth is captured as three separate dropdowns (day / month / year),
// so the parts have to be validated together rather than field by field.

function pad (num, size) {
  var s = num + ''
  while (s.length < size) s = '0' + s
  return s
}

export function dayOptions () {
  var days = []
  for (var d = 1; d < 32; d++) {
    days.push(d)
  }
  return days
}

export function monthOptions () {
  var months = []
  for (var m = 1; m < 13; m++) {
    months.push(m)
  }
  return months
}

export function yearOptions () {
  var years = []
  var thisYear = new Date().getFullYear()
  for (var y = thisYear; y > 1900; y--) {
    years.push(y)
  }
  return years
}

// True only once all three parts are chosen and they form a real calendar date
// that isn't in the future.
export function isValidDob (day, month, year) {
  return dobError(day, month, year) === null && !!day && !!month && !!year
}

// Returns a message describing what is wrong with the chosen date, or null if
// it is fine. Returns null while parts are still missing - the per-field
// 'required' rules report that case.
export function dobError (day, month, year) {
  if (!day || !month || !year) return null

  var d = parseInt(day, 10)
  var m = parseInt(month, 10)
  var y = parseInt(year, 10)

  // JavaScript rolls impossible dates over (31 Feb becomes 3 Mar), so check the
  // parts survived the round trip
  var date = new Date(y, m - 1, d)
  if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) {
    return 'Please enter a valid date of birth'
  }

  var today = new Date()
  today.setHours(0, 0, 0, 0)
  if (date.getTime() > today.getTime()) {
    return 'Date of birth cannot be in the future'
  }

  return null
}

// Cognito stores birthdate as YYYY-MM-DD
export function formatDob (day, month, year) {
  return year + '-' + pad(month, 2) + '-' + pad(day, 2)
}
